<template>
    <div class="carousel-component">
        <div :class="['main-carousel', classSelector, { 'dot-top': dotTop }]" ref="carousel">
            <div v-for="(slide, index) in slidesTotal" :key="'slide-' + (index + 1)" class="carousel-cell">
                <slot :name="'slide-' + (index + 1)"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Flickity from 'flickity';
export default {
    data: () => ({
        flickity: undefined
    }),
    props: {
        infinite: {
            type: Boolean,
            default: true
        },
        slidesTotal: {
            type: Number,
            default: 0
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        autoplayDelay: {
            type: Number,
            default: 0
        },
        classSelector: {
            type: String,
            default: ''
        },
        pageDots: {
            type: Boolean,
            default: true
        },
        navigationButtons: {
            type: Boolean,
            default: false
        },
        dotTop: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.flickity = new Flickity(this.classSelector ? `.main-carousel.${this.classSelector}` : '.main-carousel', {
            wrapAround: this.infinite,
            autoPlay: this.autoplayDelay ? this.autoplayDelay : this.autoplay,
            pageDots: this.pageDots,
            prevNextButtons: this.navigationButtons
        });
    },
    methods: {
        nextSlide() {
            this.flickity.next(true, true);
        },
        previousSlide() {
            this.flickity.previous(true, true);
        },
        reloadCells: function() {
            this.flickity.reloadCells();
            this.flickity.resize();
        }
    }
};
</script>
<style>
.carousel-component {
    width: 100%;
    --dot-size: 8px;
}

.carousel-component .flickity-page-dots {
    bottom: 0px;
    position: relative;
}
.carousel-component .flickity-page-dots .dot {
    width: var(--dot-size);
    height: var(--dot-size);
    background-color: #dbdbdb;
}
.carousel-component .flickity-page-dots .dot.is-selected {
    background-color: var(--color--light-blue);
}

.carousel-component .dot-top .flickity-page-dots {
    bottom: 100% !important;
    position: absolute !important;
}

@media screen and (max-width: 1366px) {
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 992px) {
}
</style>
